import * as React from "react";
import type { SVGProps } from "react";
const SvgFirstAid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "none"}
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      d="M9.875 4.063v1.875a.75.75 0 0 1-.75.75H6.688v2.437a.75.75 0 0 1-.75.75H4.063a.75.75 0 0 1-.75-.75V6.688H.874a.75.75 0 0 1-.75-.75V4.063a.75.75 0 0 1 .75-.75h2.438V.874a.75.75 0 0 1 .75-.75h1.875a.75.75 0 0 1 .75.75v2.438h2.437a.75.75 0 0 1 .75.75"
    />
  </svg>
);
export default SvgFirstAid;
